module.exports = __webpack_public_path__ + "public/SiteIcons/pdf_image.png?e7cf0ee3";